import { render } from "./HRFieldLinkButton.vue?vue&type=template&id=0c897d72"
import script from "./HRFieldLinkButton.vue?vue&type=script&lang=js"
export * from "./HRFieldLinkButton.vue?vue&type=script&lang=js"

import "./HRFieldLinkButton.vue?vue&type=style&index=0&id=0c897d72&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__